export default __webpack_public_path__ + "img/filter_PA.28fd3f8d65a83eb02927e774ea0cb536.jpg";